//container component

import { cn } from "~/styles/utils";


export default function Container({ children, className }: { children: React.ReactNode, className?: string }) {
  return <div className={cn("container w-full lg:w-[1170px] flex items-start mx-auto px-4", className)}>{children}</div>;
}
